import styled from "styled-components";

interface Props {
  $isSent?: boolean;
}

// container da lista toda
export const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end; /* joga as msgs pro fim */
  flex: 1;
  min-height: calc(100vh - 120px); /* garante altura mesmo sem msgs */
  padding: 12px;
  height: auto;
  overflow-y: auto;
  background: #eceff3;
`;

export const MessageRow = styled.div<Props>`
  display: flex;
  justify-content: ${({ $isSent }) => ($isSent ? "flex-end" : "flex-start")};
  margin: 6px 0;
`;

// bolha da mensagem
export const MessageBubble = styled.div<Props>`
  max-width: 70%;
  padding: 10px 12px;
  background: ${({ $isSent }) => ($isSent ? "#BCE7F4" : "#fff")};
  border-radius: ${({ $isSent }) =>
    $isSent ? "12px 12px 0 12px" : "12px 12px 12px 0"};
  box-shadow: 0 1px 2px #00000020;
  font-size: 14px;
  line-height: 1.4;
  position: relative;

  .message-text {
    white-space: pre-wrap;
    word-wrap: break-word;
    margin-bottom: 4px;
  }

  .message-info {
    display: flex;
    justify-content: flex-end;
    font-size: 11px;
    color: #555;
  }

  .push-name {
    font-size: 12px;
    font-weight: 600;
    color: #555;
    margin-bottom: 4px;
  }
`;

export const MessageDateContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px 0;

  .date-label {
    background: #eee;
    color: #555;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
  }
`;
